<template>
  <div class="footer">
    <div class="footerBox">
      <div>
        <a href="https://beian.miit.gov.cn">© 辽ICP备2022001874号-1</a>
      </div>
      <div>
        <span class="pointer">联系我们：</span>
        <span class="tel">4006660130</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
export default {
  setup() {
    const router = useRouter()
    const target = (type) => {
      if (type === 'home') {
        router.push('/home')
      } else {
        console.log(1)
        router.push('/product')
      }
    }
    return {
      target,
    }
  },
}
</script>

<style lang="scss" scoped>
.footer {
  height: 0.48rem;
  background-color: #696969;
  color: #fff;
  font-size: 0.12rem;
  .footerBox {
    width: 12rem;
    height: 0.48rem;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
a {
  color: #fff;
}
.pointer {
  font-weight: 200;
}
.ml {
  margin-left: 0.5em;
  img {
    vertical-align: middle;
    transform: translateY(-2px);
  }
}
.tel {
  font-size: 12px;
  font-weight: 200;
}
</style>
